import React from 'react'

import { Table, TableBody, TableRow, TableCell } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

import helpers from 'helpers'

const SettingsAddressTable = ({ address, isLoading }) => {
  return !isLoading ? (
    <Table>
      <TableBody>
        <TableRow hover>
          <TableCell width="30%">CEP</TableCell>
          <TableCell>{helpers.people.formatCep(address.postalCode)}</TableCell>
        </TableRow>
        <TableRow hover>
          <TableCell>Endereço</TableCell>
          <TableCell>{address.street}</TableCell>
        </TableRow>
        <TableRow hover>
          <TableCell>Número</TableCell>
          <TableCell>{address.number}</TableCell>
        </TableRow>
        <TableRow hover>
          <TableCell>Bairro</TableCell>
          <TableCell>{address.neighborhood}</TableCell>
        </TableRow>
        <TableRow hover>
          <TableCell>Cidade</TableCell>
          <TableCell>{address.city}</TableCell>
        </TableRow>
        <TableRow hover>
          <TableCell>Estado</TableCell>
          <TableCell>{address.state}</TableCell>
        </TableRow>
        <TableRow hover>
          <TableCell>Complemento</TableCell>
          <TableCell>{address.complement}</TableCell>
        </TableRow>
      </TableBody>
    </Table>
  ) : (
    <SkeletonTable />
  )
}

const SkeletonTable = () => (
  <Table>
    <TableBody>
      <TableRow hover>
        <TableCell width="30%">CEP</TableCell>
        <TableCell>
          <Skeleton variant="rect" width="100%" height={21} />
        </TableCell>
      </TableRow>
      <TableRow hover>
        <TableCell width="30%">Endereço</TableCell>
        <TableCell>
          <Skeleton variant="rect" width="100%" height={21} />
        </TableCell>
      </TableRow>
      <TableRow hover>
        <TableCell width="30%">Número</TableCell>
        <TableCell>
          <Skeleton variant="rect" width="100%" height={21} />
        </TableCell>
      </TableRow>
      <TableRow hover>
        <TableCell width="30%">Bairro</TableCell>
        <TableCell>
          <Skeleton variant="rect" width="100%" height={21} />
        </TableCell>
      </TableRow>
      <TableRow hover>
        <TableCell width="30%">Cidade</TableCell>
        <TableCell>
          <Skeleton variant="rect" width="100%" height={21} />
        </TableCell>
      </TableRow>
      <TableRow hover>
        <TableCell width="30%">Estado</TableCell>
        <TableCell>
          <Skeleton variant="rect" width="100%" height={21} />
        </TableCell>
      </TableRow>
      <TableRow hover>
        <TableCell width="30%">Complemento</TableCell>
        <TableCell>
          <Skeleton variant="rect" width="100%" height={21} />
        </TableCell>
      </TableRow>
    </TableBody>
  </Table>
)

export default SettingsAddressTable
